import { useCalendar } from "Components/Common/hooks/useCalendar";
import { useProfile } from "Components/Profile/hooks/useProfile";
import { CollectionPath, db } from "Configs/firebase";
import { createDocumentStore } from "Store/helpers/createDocumentStore";
import { checkCompanySetting, isCompanySetting } from "domain-entities";
import { doc } from "firebase/firestore";
import { useEffect } from "react";

export const useCompanySetting = createDocumentStore({
	is: isCompanySetting,
	check: checkCompanySetting,
	onSnapshot: () => {
		useCalendar.getState().refreshStartOfWeek();
		useCalendar.getState().refreshWorkingMinutes();
	},
});

export const useSubscribeToCompanySetting = () => {
	const companyId = useProfile((state) => state.item?.company);

	useEffect(() => {
		if (!companyId) return;

		const ref = doc(db, CollectionPath.COMPANY_SETTINGS, companyId);
		const unsubscribe = useCompanySetting.getState().subscribe(ref);

		return () => {
			unsubscribe();
			useCompanySetting.getState().reset();
		};
	}, [companyId]);
};
